import logger from 'lib/logger';
import React from 'react';
import { isPepperTransactionCapturedAmountSummary } from '../../model/PepperPay';
import { pepperPayApi } from '../../pepperPayApi';
import { getTransactionsFilterBody, PepperTransactionsFilter } from './usePepperTransactionsFilter';
import { TRANSACTIONS_PAGE_LIMIT } from './usePepperTransactions';
import {
    capturedAmountSummaryFromTransaction,
    FormattedCapturedAmountTotal,
    formatCapturedAmountTotals
} from './capturedAmountTotal';

export function useCapturedAmountTotal(filter: PepperTransactionsFilter) {
    const [loading, setLoading] = React.useState(true);
    const [error, setError] = React.useState(false);
    const [totals, setTotals] = React.useState<FormattedCapturedAmountTotal[]>([]);
    React.useEffect(() => {
        let cancelled = false;
        const getTotal = async () => {
            setLoading(true);
            setError(false);
            try {
                if (filter.paymentIntentId) {
                    const { body, ok } = await pepperPayApi.transactions.get(filter.paymentIntentId);
                    if (cancelled) {
                        return;
                    }
                    if (!ok) {
                        throw new Error('Could not load the captured amount total');
                    }
                    setTotals(formatCapturedAmountTotals(capturedAmountSummaryFromTransaction(body)));
                } else {
                    const filterBody = getTransactionsFilterBody(filter);
                    const { body, ok } = await pepperPayApi.transactionsSearch.create({
                        url: '/summary',
                        body: { page: { limit: TRANSACTIONS_PAGE_LIMIT }, ...filterBody }
                    });
                    if (cancelled) {
                        return;
                    }
                    if (!ok || !isPepperTransactionCapturedAmountSummary(body)) {
                        throw new Error('Could not load the captured amount total');
                    }
                    setTotals(formatCapturedAmountTotals(body));
                }
            } catch (e) {
                if (!cancelled) {
                    logger.error(e);
                    setError(true);
                    setTotals([]);
                }
            }
            if (!cancelled) {
                setLoading(false);
            }
        };
        getTotal();
        return () => {
            cancelled = true;
        };
    }, [filter]);
    return { totals, loading, error };
}
